import { z } from 'zod';
import { dateFilterSchema } from '../../../../../helpers/dateFilterSchema';

export const draftFilterSchema = dateFilterSchema.extend({
	operation: z
		.object({
			value: z.string(),
			label: z.string().optional(),
		})
		.nullable()
		.optional()
		.transform((value) => value?.value),
	orderTypeId: z
		.object({
			value: z.string(),
			label: z.string().optional(),
		})
		.nullable()
		.optional()
		.transform((value) => value?.value),
	query: z.string().optional(),
});

export type DraftFilterSchemaType = z.infer<typeof draftFilterSchema>;
